export const CloseIcon = (): JSX.Element => (
  <svg
    className="cursor-pointer"
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8514 11.4999L16.9723 7.38864C17.1527 7.20819 17.2541 6.96343 17.2541 6.70823C17.2541 6.45302 17.1527 6.20827 16.9723 6.02781C16.7918 5.84735 16.5471 5.74597 16.2919 5.74597C16.0366 5.74597 15.7919 5.84735 15.6114 6.02781L11.5002 10.1486L7.38894 6.02781C7.20848 5.84735 6.96372 5.74597 6.70852 5.74597C6.45331 5.74597 6.20856 5.84735 6.0281 6.02781C5.84764 6.20827 5.74626 6.45302 5.74626 6.70823C5.74626 6.96343 5.84764 7.20819 6.0281 7.38864L10.1489 11.4999L6.0281 15.6111C5.93828 15.7002 5.86698 15.8062 5.81833 15.923C5.76968 16.0398 5.74463 16.165 5.74463 16.2916C5.74463 16.4181 5.76968 16.5433 5.81833 16.6601C5.86698 16.7769 5.93828 16.8829 6.0281 16.972C6.11719 17.0618 6.22318 17.1331 6.33997 17.1817C6.45675 17.2304 6.58201 17.2554 6.70852 17.2554C6.83503 17.2554 6.96029 17.2304 7.07707 17.1817C7.19385 17.1331 7.29985 17.0618 7.38894 16.972L11.5002 12.8511L15.6114 16.972C15.7005 17.0618 15.8065 17.1331 15.9233 17.1817C16.0401 17.2304 16.1653 17.2554 16.2919 17.2554C16.4184 17.2554 16.5436 17.2304 16.6604 17.1817C16.7772 17.1331 16.8832 17.0618 16.9723 16.972C17.0621 16.8829 17.1334 16.7769 17.182 16.6601C17.2307 16.5433 17.2557 16.4181 17.2557 16.2916C17.2557 16.165 17.2307 16.0398 17.182 15.923C17.1334 15.8062 17.0621 15.7002 16.9723 15.6111L12.8514 11.4999Z"
      fill="#9092A3"
    />
  </svg>
);

export const SearchIcon = (): JSX.Element => (
  <svg
    className="cursor-pointer"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5028 21.5016L17.7163 17.7151M19.7619 12.797C19.7619 16.6429 16.6441 19.7607 12.7982 19.7607C8.95223 19.7607 5.83447 16.6429 5.83447 12.797C5.83447 8.95101 8.95223 5.83325 12.7982 5.83325C16.6441 5.83325 19.7619 8.95101 19.7619 12.797Z"
      stroke="#9092A3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BackIcon = (): JSX.Element => (
  <svg
    width="18"
    height="14"
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.49012e-08 7C1.49012e-08 7.55228 0.447715 8 1 8H17C17.5523 8 18 7.55228 18 7C18 6.44772 17.5523 6 17 6H1C0.447715 6 1.49012e-08 6.44772 1.49012e-08 7Z"
      fill="#9092A3"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.70711 0.292893C8.09763 0.683417 8.09763 1.31658 7.70711 1.70711L2.41421 7L7.70711 12.2929C8.09763 12.6834 8.09763 13.3166 7.70711 13.7071C7.31658 14.0976 6.68342 14.0976 6.29289 13.7071L0.292893 7.70711C-0.0976311 7.31658 -0.0976311 6.68342 0.292893 6.29289L6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893Z"
      fill="#9092A3"
    />
  </svg>
);
